<template>
	<div class="card-wrapper">
		<div class="cards-list">
			<router-link
				v-for="card in actionList" 
				:key="card.name" 
				class="action-card"
				:style="getStyleCard(card)"
				:to="getCardUrl(card)"
				:replace="shouldReplace">
				<span class="action-count" :style="getStyleCount(card)">{{ data[card.status] }}</span>
				<span class="action-name">{{card.name}}</span>
				<i class="el-icon-back reverse"></i>
			</router-link>
		</div>
		<ActionStatus
			:patientNo="data[getCardStatus.status]"
			:action="getCardStatus.status"
			v-if="showStatus">
		</ActionStatus>
	</div>
</template>

<script>
import ActionStatus from './ActionStatus'
import { getActionList } from './static'


export default {
	name: 'action-cards',
	props: {
		event: {
			type: Object,
			default: () => ({})
		},
		dateRange: {
			type: Array
		},
		showStatus: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	created() {
		this.actionList = getActionList()
	},
	data() {
		return {
			eventName: 'endoscopy'
		}
	},
	methods: {
		getStyleCard(card) {
			let styleCard = this.getCardUrl(card) === this.$route.fullPath ? `background: ${card.color};` : ''
			if(this.data[card.status] === 0) styleCard += 'pointer-events: none;'
			return  styleCard
		},
		getCardUrl(card) {
			let eventUrl = `/engagement/${this.$route.params.profileId}/${this.event.id}?status=${card.status}`
			if(this.dateRange[0]) eventUrl += '&start=' + this.dateRange[0].setHours(0,0,0,0)
			if(this.dateRange[1]) eventUrl += '&end=' + this.dateRange[1].setHours(0,0,0,0)
			return eventUrl
		},
		getStyleCount(card) {
			return this.getCardUrl(card) === this.$route.fullPath ? `background-color: #ffffff;color: ${card.color}` : `background: ${card.color}`
		},
	},
	computed: {
		getCardStatus() {
			return  this.actionList.find(card => card.status === this.$route.query.status)
		},
		shouldReplace() {
			return this.$route.params.hasOwnProperty('eventId')
		}
	},
	components: {
		ActionStatus
	}
}
</script>

<style lang="scss" scoped>
.cards-list{
	display: flex;
	justify-content: space-between;
	margin-top: 20px; 
}
.action-card{
	display: flex;
	justify-content: space-between;
	flex-grow: 1;
	padding: 18px 12px;
	align-items: center;
	box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.15);
	margin-right: 14px;
	cursor: pointer;
	text-decoration: none;
	color: #333333;
	&.router-link-exact-active{
		color: #ffffff;
	}
	.action-count{
		width: 40px;
		height: 40px;
		border-radius: 100%;
		text-align: center;
		color: #ffffff;
		padding-top: 10px;
		font-size: 20px;
	}
	.action-name{
		flex-grow: 1;
		padding-left: 10px;
	}
	.el-icon-back.reverse{
		transform: rotate(180deg)
	}
}
</style>
